export const stable = (o: unknown) =>
	JSON.stringify(o ?? {}, (_, value) => {
		if (value && typeof value === 'object' && !Array.isArray(value)) {
			return Object.keys(value)
				.sort()
				.reduce(
					(sorted, key) => {
						sorted[key] = value[key];
						return sorted;
					},
					{} as Record<string, unknown>,
				);
		}
		return value;
	});
